import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CategoryDto, KeywordDto, FirstStepData, FilterMatch } from '../../shared/model';
import * as $ from 'jquery';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.css', '../../shared/styles/translation.css', '../main-view.component.css']
})
export class FirstStepComponent implements AfterViewInit {
  @Input() active: boolean;
  @Input() categories: Array<CategoryDto>;
  @Input() keywords: Array<KeywordDto>;
  @Input() dropdownData: Array<KeywordDto>;
  @Input() isStepClosed: boolean;

  @Output() change: EventEmitter<FirstStepData> = new EventEmitter();

  @ViewChild('issueInput', { static: false }) issueInput: ElementRef;
  @ViewChild('combobox', { static: false }) combobox: any;

  public chosenKeyword: KeywordDto;
  public issueDescription: string;
  public inputKeyword: string;
  public isCategorySelected: boolean;
  public chosenCategory: CategoryDto;
  public isInputActive: boolean;
  public nothingMatches: boolean;

  private data: FirstStepData = <FirstStepData>{};

  constructor() {
  }

  ngAfterViewInit() {
    this.setMaxKeywordLengthLimit();
  }

  public onCategoryClick(categoryId) {
    this.chosenCategory = this.categories.find(c => c.Id === categoryId);
    this.isCategorySelected = true;
    this.isInputActive = false;
    this.change.emit(this.getData());
  }

  public onEditCategoryClick() {
    this.chosenCategory = undefined;
    this.clearElements();
    this.issueDescription = null;
    this.change.emit(this.getData());
  }

  public inputFocus(event) {
    if (!this.isInputActive) {
      this.isInputActive = true;
      event.preventDefault();
    }
  }

  public changeToInputView() {
    this.isInputActive = true;
  }

  public backToCategories() {
    this.clearElements();
    this.change.emit(this.getData());
  }

  public onValueChange(keyword: KeywordDto) {
    if (!!keyword && keyword.Id.trim() === '') {
      const matchedKey = this.matchInputToKeyword(keyword);

      if (matchedKey !== undefined) {
        this.chosenKeyword = matchedKey;
      }
    }

    this.markSelectedKeywordInCombobox();
  }

  public markSelectedKeywordInCombobox() {
    this.nothingMatches = false;
    let tags;
    setTimeout(function () {
      tags = $('li[class="k-button ng-star-inserted"]');
      if (tags.length > 0) {
        for (let i = 0; i < tags.length; i++) {
          $(tags[i]).addClass('input-selected-keyword');
        }
      }
    }, 0);
  }

  public onNothingMatchesClick() {
    this.nothingMatches = true;
    this.chosenKeyword = null;
    setTimeout(() => {
      this.issueInput.nativeElement.focus();
    }, 0);
  }

  public onSearchClick() {
    if (!!this.chosenKeyword) {
      if (this.chosenKeyword.Id !== '') {
        this.onScheduleClick();
      } else {
        this.data.MismatchedKeyword = this.chosenKeyword.Name;
        this.onNothingMatchesClick();
      }
    } else {
      this.onNothingMatchesClick();
    }
  }

  public onKeydown(event) {
    if (event.key === 'Enter') {
      if (this.nothingMatches) {
        this.onScheduleClick();
      } else {
        this.onSearchClick();
      }
    }
  }

  public onScheduleClick() {
    if (!!this.chosenKeyword) {
      this.chosenCategory = this.categories.find(e => e.Id === this.chosenKeyword.CategoryId);
    } else {
      this.setChosenCategoryToWorkplace();
    }

    this.isCategorySelected = true;
    this.change.emit(this.getData());
  }

  public handleFilter(input: string) {
    const inputKeyword = <KeywordDto>{
      Name: input,
      Id: ''
    };

    if (input.length >= 1 && input.trim().length > 0) {
      this.dropdownData = [inputKeyword].concat(this.bestMatchFilter(input));
    } else {
      this.dropdownData = this.keywords;
    }
  }

  public isKeyword(dropdownElement: KeywordDto): boolean {
    return dropdownElement.Id !== '';
  }

  public matchInputToKeyword(keyword: KeywordDto): KeywordDto {
    return this.keywords.find(k => k.Name.toLowerCase() === keyword.Name.toLowerCase());
  }

  private setChosenCategoryToWorkplace() {
    const defaultCategory = this.categories.find(e => e.Default === true);
    this.chosenCategory = defaultCategory;
  }

  private clearElements() {
    this.isCategorySelected = false;
    this.issueDescription = undefined;
    this.isInputActive = false;
    this.chosenKeyword = null;
    this.nothingMatches = false;
    this.dropdownData = this.keywords;
  }

  private getData(): FirstStepData {
    this.data.Submit = this.isCategorySelected;
    this.data.Category = this.chosenCategory;
    this.data.Keyword = this.chosenKeyword;
    this.data.ProblemDescription = this.issueDescription;

    return this.data;
  }

  private bestMatchFilter(input: string): KeywordDto[] {
    const inputKeywords = input.split(' ');
    const filterGrading: FilterMatch[] = Array.from(this.keywords.map(d => <FilterMatch>{
      Keyword: d,
      FullyContainedKeywords: this.countIncludedKeywords(d.Name, inputKeywords),
      IndexOfMatch: this.getIndexOfMatch(d.Name, input),
      InputFullyIncluded: this.containsFullInput(d.Name, input),
      MatchedCharacters: this.countMatchedCharacters(d.Name, input)
    }));

    const sortedresult = filterGrading.sort((a, b) => this.compareKeywordsMatch(a, b));

    const mappedresult = sortedresult.map(item => item.Keyword);
    return mappedresult;
  }

  private countIncludedKeywords(keyword: string, input: string[]): number {
    let count = 0;

    input.forEach(i => {
      if (keyword.toLowerCase().indexOf(i.toLowerCase()) > -1) {
        count++;
      }
    });

    return count;
  }

  private containsFullInput(keyword: string, input: string): boolean {
    return keyword.toLowerCase().indexOf(input.toLowerCase()) > -1;
  }

  private countMatchedCharacters(keyword: string, input: string): number {
    return keyword.split('').map(k => k.toLowerCase()).filter(c => input.toLowerCase().indexOf(c) > -1).length;
  }

  private getIndexOfMatch(keyword: string, input: string): number {
    const index = keyword.toLowerCase().indexOf(input.toLowerCase());
    return index > -1 ? index : 99;
  }

  private compareKeywordsMatch(keyword1: FilterMatch, keyword2: FilterMatch): number {
    if (keyword1.InputFullyIncluded === keyword2.InputFullyIncluded) {
      return this.compareFullyContainedKeywords(keyword1, keyword2);
    }
    return keyword1.InputFullyIncluded ? -1 : 1;
  }

  private compareFullyContainedKeywords(keyword1: FilterMatch, keyword2: FilterMatch): number {
    if (keyword1.FullyContainedKeywords === keyword2.FullyContainedKeywords) {
      return this.compareIndexOfMatch(keyword1, keyword2);
    }
    return keyword1.FullyContainedKeywords > keyword2.FullyContainedKeywords ? -1 : 1;
  }

  private compareIndexOfMatch(keyword1: FilterMatch, keyword2: FilterMatch) {
    if (keyword1.IndexOfMatch === keyword2.IndexOfMatch) {
      return this.compareNumOfMatchedCharacters(keyword1, keyword2);
    }
    return keyword1.IndexOfMatch < keyword2.IndexOfMatch ? -1 : 1;
  }

  private compareNumOfMatchedCharacters(keyword1: FilterMatch, keyword2: FilterMatch): number {
    if (keyword1.MatchedCharacters === keyword2.MatchedCharacters) {
      return 0;
    }
    return keyword1.MatchedCharacters > keyword2.MatchedCharacters ? -1 : 1;
  }

  private setMaxKeywordLengthLimit() {
    if (this.combobox && !!this.combobox.wrapper.children && !!this.combobox.wrapper.children[0]) {
      const span = this.combobox.wrapper.children[0];

      if (!!span.children && !!span.children[0]) {
        const searchbar = span.children[0];

        if (!!searchbar.children && !!searchbar.children[0]) {
          const input = searchbar.children[0];
          input.maxLength = environment.maxKeywordLength;
        }
      }
    }
  }

  public isIssueDescriptionAllowed() : boolean {
    return this.categories && this.categories.findIndex(cat => cat.Default) != -1 && this.nothingMatches;
  }
}
